import React from "react";
import ViewHandymanForms from "../ViewHandymanForms/ViewHandymanForm";

const EditHandyman = () => {
    return(
        <ViewHandymanForms type="Edit"/>
    )
}

export default EditHandyman